import { useEffect, useState } from 'react';
import { useEditCommentsMutation } from '../../../empresaApi';
import { isFetchBaseQueryError, parseErrorToDetailProblem } from '../../../../../utils/errorHelpers';
import { ErrorMessage } from '../../../../../components/errors/ErrorMessage';
import { ActionButtons } from 'src/components/ui/ActionButtons';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';

interface Props {
    empresaId: number;
    text?: string;
}

export function EditComments({ empresaId, text }: Props) {
    const iconSize = 20;


    const [textEdited, setTextEdited] = useState(text ?? "");
    const [defaultText, setDefaultText] = useState(text ?? "");
    const [isDirty, setIsDirty] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [editComments, { isLoading }] = useEditCommentsMutation();

    const handleEditComments = async () => {
        try {
            setErrorMessage(null);

            if(textEdited == undefined) return;

            const request = {
                empresaId,
                text: textEdited,
            };

            await editComments(request).unwrap();

            setDefaultText(textEdited)
            setIsDirty(false);
        } catch (exception) {
            if(!isFetchBaseQueryError(exception))
            {
                console.error(exception);
                return;
            }
            const error = parseErrorToDetailProblem(exception);
            setErrorMessage(error ? error.title : "Ha ocurrido un error intente mas tarde");
        }
    }

    useEffect(() => {
        setIsDirty(textEdited != defaultText);
    }, [textEdited])

    return (
        <div className="mb-[11px] mx-1">
            <div className="flex items-center gap-x-2">
                <ArticleRoundedIcon sx={{ height: iconSize, width: iconSize }}/>
                <label className="font-semibold min-w-[140px]">Comentarios</label>
            </div>

            <textarea
                onChange={(event) => setTextEdited(event.target.value)}
                value={textEdited}
                placeholder="Escribe un comentario..."
                className="
                    w-full h-[100px] rounded-[3px] my-1 px-2 
                    font-semibold text-gray-800 text-sm resize-none
                    border border-white focus:outline-gray-400
                    disabled:bg-white">
            </textarea>

            {isDirty && (
            <ActionButtons 
                isLoading={isLoading}
                saveButtonText="Actualizar"
                saveButtonType="button"
                onSave={handleEditComments}
                onCancel={() => {
                    setErrorMessage(null);
                    setTextEdited(defaultText);
                }}
                />
            )}

            {errorMessage && (
            <div className="my-2">
                <ErrorMessage 
                    customMessage>
                    <p className="text-sm">{errorMessage}</p>
                </ErrorMessage>
            </div>
            )}
        </div>
    );
}
